import { Grid, Skeleton, Typography } from '@mui/material'

import classes from './index.styles'

type IProps =
  | {
      isLoading: true
      label?: string
      value?: string | number | null
    }
  | {
      isLoading?: false
      label: string
      value: string | number | null
    }

const DeviceInfoItem = ({ label, value, isLoading }: IProps) => {
  return (
    <Grid container={true} size={12} sx={classes.deviceInfoItem}>
      <Typography variant="body2" sx={classes.deviceInfoLabel}>
        {isLoading ? <Skeleton width={100} /> : label}
      </Typography>

      <Typography variant="body2" sx={classes.deviceInfoValue}>
        {isLoading ? <Skeleton width={120} /> : value}
      </Typography>
    </Grid>
  )
}

export default DeviceInfoItem
